import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { IAgent } from "./agents"

export const agentsOld: IGenericModel<IAgent> = { ...generic(endpoints.AGENT_OLD) }
